import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../Header/Main';
import Blogdtls from '../../Menblogdetails/Blogdtls';
import Comment from '../../Menblogdetails/Comment';
import Rowcmnt from '../../Menblogdetails/Rowcmnt';
import Footer from '../../Footer/Main';
import Aos from 'aos';
import { blogApi } from '../../../services/api';
import logger from '../../../utils/logger';

function BlogDetails() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [category, setCategory] = useState(null);
    const [comments, setComments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        Aos.init();
        Aos.refresh();

        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                const [blogData, commentsData] = await Promise.all([
                    blogApi.fetchBlogPostById(id),
                    blogApi.fetchBlogPostComments(id),
                ]);

                setBlog(blogData);
                setComments(commentsData);

                // Fetch category if available
                if (blogData?.category) {
                    try {
                        const catData = await blogApi.fetchBlogCategoryById(blogData.category);
                        setCategory(catData);
                    } catch (catErr) {
                        logger.warn('Failed to fetch blog category', catErr);
                        // Category is optional, continue without it
                    }
                }
            } catch (err) {
                logger.error("Error loading blog page", err);
                setError('Failed to load blog post. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    if (loading) {
        return (
            <>
                <Header />
                <div className="page_wrapper">
                    <div style={{ padding: '50px', textAlign: 'center' }}>
                        <p>Loading blog...</p>
                    </div>
                </div>
            </>
        );
    }

    if (error || !blog) {
        return (
            <>
                <Header />
                <div className="page_wrapper">
                    <div style={{ padding: '50px', textAlign: 'center' }}>
                        <p>{error || 'Blog post not found'}</p>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="page_wrapper">
                <Blogdtls blog={blog} category={category} commentsCount={comments.length} />
                <Comment comments={comments} blogId={id} />
                <Rowcmnt blogId={id} onNewComment={(c) => setComments(prev => [...prev, c])} />
                <Footer />
            </div>
        </>
    );
}

export default BlogDetails;
